module.exports = __webpack_public_path__ + "static/img/101844.853eeb8d.png";